module.exports = __webpack_public_path__ + "img/9.ea20fa4b.png";